import { render, staticRenderFns } from "./CompanyInvoices.vue?vue&type=template&id=5978931e&"
import script from "./CompanyInvoices.vue?vue&type=script&lang=ts&"
export * from "./CompanyInvoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5978931e')) {
      api.createRecord('5978931e', component.options)
    } else {
      api.reload('5978931e', component.options)
    }
    module.hot.accept("./CompanyInvoices.vue?vue&type=template&id=5978931e&", function () {
      api.rerender('5978931e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInvoices.vue"
export default component.exports